module.exports = __webpack_public_path__ + "img/c04_unitwarwagon_Normal_ua.92154551.webp";